import { render, staticRenderFns } from "./PlotItemDetail.vue?vue&type=template&id=56886d74&scoped=true"
import script from "./PlotItemDetail.vue?vue&type=script&lang=ts"
export * from "./PlotItemDetail.vue?vue&type=script&lang=ts"
import style0 from "./PlotItemDetail.vue?vue&type=style&index=0&id=56886d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56886d74",
  null
  
)

export default component.exports